<template>
  <div>
    <top-bar></top-bar>
    <banner></banner>
    <core></core>
    <product></product>
    <news></news>
    <team></team>
    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
import TopBar from './TopBar'
import Banner from './Banner'
import Core from './Core'
import Product from './Product'
import News from './News'
import Team from './Team'
import BottomBar from './BottomBar'
export default {
  name: 'HelloWorld',
  components: {
    TopBar,
    Banner,
    Core,
    Product,
    News,
    Team,
    BottomBar
  },
  data () {
    return {
      msg: ''
    }
  },
  mounted() {
    if(this.$route.query.lan) {
      this.bus.nowLan = this.$route.query.lan
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue